import css from 'styled-jsx/css';

const styles = css`:root {
    /* @TODO get a hold of/unify these colors...
       tell design to stop giving us a new color palatte
       with each new design...
    */

    /* New II Design Pattern - Introduced 11-12-2019 */
    /* TODO: --grey-800 is the color for primary text and should be used throughout the entire application */
}
:root {

    /* Margin and padding should be in multiples of 8 (i.e.---8, 16, 24) */

    /* New II Design Pattern - Introduced 11-12-2019 */
}
:root {

    /* New II Design Pattern - Introduced 11-12-2019 */
}
/* @import '@trp-beacon-ui-kit/foundation/style-tokens/css/variables.css'; */
h3 {
    font-size: 14px;
  font-family: 'Nimbus Sans', sans-serif;
  font-weight: 400;
  font-style: normal;
    color: #111111;
}
.container :global(h2:first-of-type) {
    margin-top: 0;
}
.pie-container {
    display: flex;
    align-items: center;
    width: -webkit-max-content;
    width: max-content;
    width: 100%;
    max-width: 600px;
    margin: 0 auto;
    flex-wrap: wrap;
}
.legend {
    width: 50%;
}
.legend :global(.text) {
    font-size: 14px;
}
.pie {
    margin-right: 24px;
}
@media (max-width: 720px) {
    .legend,
    .pie {
        margin: 0 auto;
    }
    .legend {
        width: 80%;
    }
    .pie {
        margin-bottom: 15px;
    }
}
`;

export default styles;